<script setup lang="ts">
import i18n from '@/lang/i18n';
import { GDialog } from 'gitart-vue-dialog'
import { computed } from "vue";

const emits = defineEmits(['update:modelValue', 'cancel', 'openModal'])

const props = defineProps<{
  modelValue: boolean
  confirm: () => void
}>()

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits('update:modelValue', value);
  },
})

const FIRST_MESSAGES = [
  'pages.dailyReports.unexpectedEventConfirmModal.messages.no1of1',
  'pages.dailyReports.unexpectedEventConfirmModal.messages.no1of2',
  'pages.dailyReports.unexpectedEventConfirmModal.messages.no1of3',
  'pages.dailyReports.unexpectedEventConfirmModal.messages.no1of4'
]

const SECOND_MESSAGES = [
  'pages.dailyReports.unexpectedEventConfirmModal.messages.example',
  'pages.dailyReports.unexpectedEventConfirmModal.messages.no2of1',
  'pages.dailyReports.unexpectedEventConfirmModal.messages.no2of2',
  'pages.dailyReports.unexpectedEventConfirmModal.messages.no2of3',
  'pages.dailyReports.unexpectedEventConfirmModal.messages.no2of4'
]
</script>
<template>
  <GDialog
    v-model="modelValue"
    transition="custom-from-bottom-transition"
    :persistent='true'
    max-width="45%"
  >
    <div
      class="modal-header justify-content-center mt-2">
      <label>
        {{ i18n.global.t('pages.dailyReports.unexpectedEventConfirmModal.title') }}
      </label>
    </div>
    <div class="modal-body mx-4">
      <div class="confirmation-modal-note">
        <div class="my-5">
          <h6>
            {{ i18n.global.t('pages.dailyReports.unexpectedEventConfirmModal.messages.no1') }}
          </h6>
          <div class="pl-3 mb-5">
            <template v-for="message in FIRST_MESSAGES" :key="message">
              <div v-text="i18n.global.t(message)" />
            </template>
          </div>
          <h6>
            {{ i18n.global.t('pages.dailyReports.unexpectedEventConfirmModal.messages.no2') }}
          </h6>
          <div class="pl-3">
            <template v-for="message in SECOND_MESSAGES" :key="message">
              <div style="white-space: pre-wrap;" v-text="i18n.global.t(message)" />
            </template>
          </div>
        </div>
      </div>
    </div>
    <div
      class="d-flex justify-content-end m-3 mt-4"
    >
      <v-btn
        class="ma-2 reset-btn"
        @click="modelValue = false"
      >
        {{ i18n.global.t('pages.common.button.return') }}
      </v-btn>
      <v-btn
        class="ma-2 exec-btn"
        @click="props.confirm"
      >
        {{ i18n.global.t('common.confirmBtn') }}
      </v-btn>
    </div>
  </GDialog>
</template>
